import Vue from 'vue'
import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const CartRepository = RepositoryFactory.get('cart')

// setup store
const state = {
  quotes: []
}

// getters
const getters = {
  quotes: (state) => {
    return state.quotes
  },
  count: (state) => {
    return state.quotes.length
  },
  partCount: (state) => (part) => {
    // don't bother checking empty quotes
    if (state.quotes.length === 0) {
      return null
    }
    let pos = state.quotes.findIndex(i => i.part === part)
    if (pos > -1) {
      return state.quotes[pos].quantity
    }
    return null
  }
}

const mutations = {
  add (state, { item }) {
    // Get position of Part in quotes
    let pos = state.quotes.findIndex(i => i.part === item.part)
    if (pos > -1) {
      // Adjust quantity
      state.quotes[pos].quantity = item.quantity
    } else {
      // Part is not in quotes
      state.quotes.push(item)
    }
  },
  update (state, { item }) {
    // Get position of Part in quotes
    let pos = state.quotes.findIndex(i => i.part === item.part)
    if (pos > -1) {
      // Adjust quantity
      state.quotes[pos].quantity = item.quantity
    }
  },
  delete (state, { item }) {
    let index = state.quotes.indexOf(item)
    state.quotes.splice(index, 1)
  },
  clear (state) {
    state.quotes = []
  }
}

const actions = {
  loadCart: ({ commit }, cart) => {
    commit({ type: 'clear', params: {} })
    cart.items.forEach(item => {
      commit({ type: 'add', item: item })
    })
  },
  loadCartRemote: ({ commit }, vue) => {
    CartRepository.getCart(vue).then(response => {
      let cart = response.data
      this.dispatch('loadCart', cart)
    }).catch(error => {
      Vue.$log.debug(error)
    })
  },
  add: ({ commit }, params) => {
    CartRepository.addItem(params.vue, params.item).then(response => {
      commit({ type: 'add', item: response.data })
    }).catch(error => {
      Vue.$log.debug(error)
    })
  },
  update: ({ commit }, params) => {
    CartRepository.updateItem(params.vue, params.item).then(response => {
      commit({ type: 'update', item: response.data })
    }).catch(error => {
      Vue.$log.debug(error)
    })
  },
  delete: ({ commit }, params) => {
    CartRepository.deleteItem(params.vue, params.item.id).then(result => {
      commit({ type: 'delete', item: params.item })
    }).catch(error => {
      Vue.$log.debug(error)
    })
  },
  clear: ({ commit }, vue) => {
    CartRepository.emptyCart(vue).then(result => {
      commit({ type: 'clear' })
    }).catch(error => {
      Vue.$log.debug(error)
    })
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
